<template>
	<main class="flex items-center mb-12 h-full" style="overflow-x: scroll;">
		<h3 class="mr-4 md:mr-8 hidden md:block">
			<strong>Status</strong>
		</h3>
		<div
			v-for="(item, i) in status"
			:key="i"
			 class="mr-6 md:mr-8 my-4"
		>
			<a href="#" @click.prevent="filterStatus(i)" :id="`status-${i}`" class="status px-8 py-2 rounded-lg" style="border: 1px solid #ccc" :class="item.class">
				<strong>{{item.label}}</strong>
			</a>
		</div>
	</main>
</template>	
<script>
	export default {
		methods: {
			filterStatus(i) {
				document.getElementsByClassName('status').forEach((item) => {
					item.setAttribute('class', 'status status px-8 py-2 rounded-lg')
					document.querySelector(`#${item.getAttribute('id')} strong`).setAttribute('class', 'text-primary text-center')
				})

				document.getElementById(`status-${i}`).setAttribute('class', 'con-vs-alert-success status px-8 py-2 rounded-lg')
			}
		},
		data: () => ({
			status: [
				{
					label: 'Semua',
					class: 'con-vs-alert-success'
				},
				{
					label: 'Pending',
					class: ''	
				},
				{
					label: 'Berhasil',
					class: ''
				},
				{
					label: 'Gagal',
					class: ''
				}
			]
		})
	}
</script>	